const domain: string = 'USER'

export const SAVE_USER: string = `${domain}/SAVE_USER`
export const REMOVE_USER: string = `${domain}/REMOVE_USER`
